import VehicleType from './vehicleTypeModel'
import SearchAreaModel from './SearchAreaModel'
import CommentModel from './commentModel'


export default class ReportModel {
    step : number = 1
    vehicleType: VehicleType = new VehicleType()
    // naam aanpassen
    check: Array<SearchAreaModel> = []
    composeComment: CommentModel = new CommentModel()

    refreshComposeComment () {
      this.composeComment = new CommentModel()
    }
}
